// Create custom hook to access context
import {LessonPlaybackStateContext} from "../context/LessonPlaybackStateContext";
import {useContext} from "react";

function useLessonPlaybackState() {
    const context = useContext(LessonPlaybackStateContext);
    if (!context) {
        throw new Error('usePlaybackState must be used within a PlaybackProvider');
    }
    return context;
}

export {useLessonPlaybackState};